module.exports = __webpack_public_path__ + "img/qx60-19.021eedcf.png";